import { render, staticRenderFns } from "./FormTaxa.vue?vue&type=template&id=93c14502"
import script from "./FormTaxa.vue?vue&type=script&lang=js"
export * from "./FormTaxa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports